// AVOIR Phase 3 UI rules (goodwill credit + customer compensation). No React, no network. Money is exact text (cents as BigInt). The server stays authoritative.
import { cents, text } from '../../../pages/Sales/invoicing/invoicingModel.mjs';

// E4 (47007): a voucher reads EXPIRED when the server says so (state 'expired', a used voucher past its date) or, on an API that does not serve the state, when an issued voucher's expiry day is before today
export const isExpiredVoucher = (a, today) => !!a && (a.state === 'expired' || (!a.state && a.status === 'issued' && !!a.expires_on && String(a.expires_on).slice(0, 10) < today));
export const GW_TONE = { active: 'good', used_up: 'mut', expired: 'warn', cancelled: 'crit', draft: 'mut' };

// '' | error key under `gw.errors.` / `comp.errors.`
export function validateGoodwill({ amount, notes, expires }, today) {
  if (!amount || cents(amount) <= 0n) return 'amount';
  if (!String(notes || '').trim()) return 'notes';
  if (expires && expires < today) return 'expiry';
  return '';
}
export function validateCompensation({ amount, reason, accountId, date }, today) {
  if (!amount || cents(amount) <= 0n) return 'amount';
  if (!accountId) return 'account';
  if (!String(reason || '').trim()) return 'reason';
  if (!date || date > today) return 'date';
  return '';
}

// credits the discount flow may draw on: active with something left, newest expiry first is not needed; server order kept.
export const usableCredits = (credits) => (credits || []).filter(c => c.state === 'active' && cents(c.remaining) > 0n);

// the discount amount typed vs the chosen credit: 'cap' when above the remaining balance (the server refuses it too: GOODWILL_EXCEEDS_BALANCE)
export const overCredit = (amount, credit) => !!credit && !!amount && cents(amount) > cents(credit.remaining);
// "cap it" helper: the amount to use when the typed one is over the credit
export const cappedAmount = (amount, credit) => (overCredit(amount, credit) ? text(cents(credit.remaining)) : amount);

// a credit can be cancelled / expired early only when nothing was used (the API answers AVOIR_HAS_USES otherwise)
// part-used (something used AND something left): the only voucher whose remainder can be released (Cancel / Expire refuse it: AVOIR_HAS_USES)
export const canReleaseRemainder = (c) => c.state === 'active' && cents(c.used) > 0n && cents(c.remaining) > 0n;
export const canVoidCredit = (c) => c.state === 'active' && cents(c.used) === 0n;
